export default __webpack_public_path__ + "static/column-span-light-db0f2354f5a9b0a6de416c18ee2560ba.png";